module.exports = __webpack_public_path__ + "static/img/activitydetailsbg.40f68fb1.png";